import { render, staticRenderFns } from "./EvaluateRecord.vue?vue&type=template&id=6d628cd6&scoped=true&"
import script from "./EvaluateRecord.vue?vue&type=script&lang=js&"
export * from "./EvaluateRecord.vue?vue&type=script&lang=js&"
import style0 from "./EvaluateRecord.vue?vue&type=style&index=0&id=6d628cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d628cd6",
  null
  
)

export default component.exports